<div
  class="d-flex h-100 align-items-center mr-2 text-muted"
  [class.text-danger]="value?.length > maxLength"
>
  <span>{{ value?.length || 0 }}</span>
  <span>/</span>
  <span>{{ maxLength }}</span>
</div>
